import './pageoverLay.css'
import loader from '../../../assets/images/rhybusicon.png'
const PageOverlay = () => {
    return (
        <div
            className="submit-bg"
            id="pageoverlay"
            role="status"
            aria-busy="true"
            aria-live="polite"
            aria-label="Loading, please wait"
        >
            <div className='copying'>
                <div className="page-loader">
                    <div className="page-loader-spinner">
                        <img src={loader} alt="" aria-hidden="true" />
                    </div>
                    <span>Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default PageOverlay